import { render, staticRenderFns } from "./ResourcesMonitoringSingleContent.vue?vue&type=template&id=8adbe568&"
import script from "./ResourcesMonitoringSingleContent.vue?vue&type=script&lang=js&"
export * from "./ResourcesMonitoringSingleContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports